
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TerminalVendidoType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TerminalVendidoType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data_venda"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usuario_venda_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"filial"},"name":{"kind":"Name","value":"filial_agvivo_id"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":129}};
    doc.loc.source = {"body":"fragment TerminalVendidoType on TerminalVendidoType {\n  id\n  numero\n  data_venda\n  usuario_venda_id\n  filial: filial_agvivo_id\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
